import React from "react";
import PropTypes from "prop-types";

import eye from "../../../../assets/graphics/icons/eye.svg";

import "features/application/field/component/view.scss";

const FieldView = ({
  label,
  placeholder,
  name,
  type,
  accept,
  autoComplete = "on",
  maxLength,
  value,
  isChecked,
  image,
  invalidFields,
  shouldValidate,
  rule,
  error,
  reference,
  references,
  styles,
  removeInvalidField,
  validate,
  togglePasswordVisibility,
  toggleGenderListVisibility,
  setGender,
  photoError,
  handleChange,
  disabled,
}) => {
  switch (type) {
    case "gender":
      return (
        <div
          className={`application__field${
            invalidFields.includes(name) ? "--error" : ""
          }`}
        >
          <label className="field__label">{label}</label>
          <input
            className="field__select"
            name={name}
            type="text"
            maxLength={maxLength}
            autoComplete={autoComplete}
            defaultValue={value}
            rule={rule}
            ref={references.gender}
            onFocus={() => removeInvalidField(name)}
            onBlur={(event) =>
              validate(name, event.target.value, rule, shouldValidate)
            }
          />
          <div
            className="field__gender"
            ref={references.genderPreview}
            onClick={toggleGenderListVisibility}
          >
            {value ? value : "Choose Here"}
          </div>
          <div
            className="field__list"
            style={{ visibility: "hidden" }}
            ref={references.genderList}
          >
            <div className="field__item" data-gender="Male" onClick={setGender}>
              Male
            </div>
            <div
              className="field__item"
              data-gender="Female"
              onClick={setGender}
            >
              Female
            </div>
            <div
              className="field__item"
              data-gender="Other"
              onClick={setGender}
            >
              Other
            </div>
          </div>
          {error && <span className="field__error">{error}</span>}
        </div>
      );
    case "textarea":
      return (
        <div
          className={`application__field${
            invalidFields.includes(name) ? "--error" : ""
          }`}
          style={styles}
        >
          <label className="field__label">{label}</label>
          <textarea
            className="field__textarea"
            placeholder={placeholder}
            name={name}
            autoComplete={autoComplete}
            maxLength={maxLength}
            defaultValue={value}
            rule={rule}
            ref={reference}
            onFocus={() => removeInvalidField(name)}
            onBlur={(event) =>
              validate(name, event.target.value, rule, shouldValidate)
            }
          ></textarea>
          {error && <span className="field__error">{error}</span>}
        </div>
      );
    case "photo":
      return (
        <div
          className={`application__field${
            invalidFields.includes(name) || photoError ? "--error" : ""
          }`}
          style={styles}
        >
          <label className="field__label">{label}</label>
          <label className="field__photo">
            <input
              className="field__file"
              name={name}
              type="file"
              accept={accept}
              autoComplete={autoComplete}
              rule={rule}
              ref={reference}
              onClick={(event) => {
                removeInvalidField(name);
                event.target.value = null;
              }}
              onChange={(event) => {
                validate(name, event.target.files[0], rule, shouldValidate);
                handleChange(event);
              }}
            />
            <img className="field__preview" src={image} alt="photo" />
          </label>
          {error && <span className="field__error">{error}</span>}
          {photoError && <span className="field__error">{photoError}</span>}
        </div>
      );
    case "checkbox":
      return (
        <div
          className={`application__field${
            invalidFields.includes(name) ? "--error" : ""
          } application__checkbox`}
        >
          <label className="field__container">
            <input
              className="field__checkbox"
              name={name}
              type={type}
              autoComplete={autoComplete}
              defaultChecked={isChecked}
              rule={rule}
              ref={reference}
              onClick={(event) =>
                validate(name, event.target.checked, rule, shouldValidate)
              }
            />
            <span className="field__checkmark"></span>
            {label}
          </label>
          {error && <span className="field__error">{error}</span>}
        </div>
      );
    case "password":
      return (
        <div
          className={`application__field${
            invalidFields.includes(name) ? "--error" : ""
          }`}
        >
          <label className="field__label">{label}</label>
          <div className="field__group">
            <input
              className="field__input"
              placeholder={placeholder}
              name={name}
              type={type}
              autoComplete={autoComplete}
              maxLength={maxLength}
              defaultValue={value}
              rule={rule}
              ref={references.password}
              onFocus={() => removeInvalidField(name)}
              onBlur={(event) =>
                validate(name, event.target.value, rule, shouldValidate)
              }
            />
            <img
              className="field__icon"
              src={eye}
              alt="eye"
              onDragStart={(event) => event.preventDefault()}
              onClick={togglePasswordVisibility}
            />
          </div>
          {error && <span className="field__error">{error}</span>}
        </div>
      );
    default:
      return (
        <div
          className={`application__field${
            invalidFields.includes(name) ? "--error" : ""
          } ${disabled ? "application__field--disabled" : ""}`}
          style={styles}
        >
          <label className="field__label">{label}</label>
          <input
            className="field__input"
            placeholder={placeholder}
            name={name}
            type={type}
            autoComplete={autoComplete}
            maxLength={maxLength}
            defaultValue={value}
            rule={rule}
            ref={reference}
            onFocus={() => removeInvalidField(name)}
            onBlur={(event) =>
              validate(name, event.target.value, rule, shouldValidate)
            }
            disabled={disabled}
          />
          {error && <span className="field__error">{error}</span>}
        </div>
      );
  }
};

FieldView.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  accept: PropTypes.string,
  autoComplete: PropTypes.string,
  maxLength: PropTypes.number,
  value: PropTypes.string,
  isChecked: PropTypes.bool,
  image: PropTypes.string,
  invalidFields: PropTypes.array,
  shouldValidate: PropTypes.bool,
  rule: PropTypes.string,
  error: PropTypes.string,
  reference: PropTypes.object,
  references: PropTypes.object,
  removeInvalidField: PropTypes.func,
  validate: PropTypes.func,
  togglePasswordVisibility: PropTypes.func,
  toggleGenderListVisibility: PropTypes.func,
  setGender: PropTypes.func,
  styles: PropTypes.object,
  handleChange: PropTypes.func,
  photoError: PropTypes.string,
  disabled: PropTypes.bool,
};

export default FieldView;
